import { useEffect, useState } from 'react';

type PROGRESS_COLORS = 'ph-purple' | 'ph-green' | 'ph-orange' | 'ph-red' | undefined;

const useTimerProgress = ({
  timer,
  timeRemaining,
  usingTimeBank,
}: {
  timer?: number;
  timeRemaining?: number;
  usingTimeBank?: boolean;
}) => {
  const [initialTimer, setInitialTimer] = useState<number | undefined>(timer);
  const [internalTimer, setInternalTimer] = useState<number | undefined>(timeRemaining);

  const timerDeltaMs = timer ?? 15;

  useEffect(() => {
    const interval = setInterval(() => {
      setInternalTimer((prevTimer) => (prevTimer && prevTimer > 0 ? prevTimer - timerDeltaMs / 1000 : undefined));
    }, timerDeltaMs);

    return () => clearInterval(interval);
  }, [timerDeltaMs]);

  useEffect(() => {
    // Reset the timer when it changes or when switching between normal and timebank
    setInitialTimer(timer);
    setInternalTimer(timeRemaining);
  }, [timer, timeRemaining, usingTimeBank]);

  if (timer === undefined || timeRemaining === undefined) {
    return { progressBarWidth: '0%', progressColor: undefined };
  }

  const progressBarWidth =
    internalTimer !== undefined && initialTimer !== undefined ? `${(internalTimer / initialTimer) * 100}%` : '0%';

  const getProgressBarColor = (): PROGRESS_COLORS => {
    if (initialTimer && internalTimer) {
      const percentage = internalTimer / initialTimer;
      if (percentage > 0.5) {
        if (usingTimeBank) {
          return 'ph-purple';
        }
        return 'ph-green';
      }
      if (percentage > 0.25) {
        return 'ph-orange';
      }
      return 'ph-red';
    }
  };

  const progressColor = getProgressBarColor();

  return { progressBarWidth, progressColor };
};

export default useTimerProgress;
